const cadastro_reordenamento_planejamento = {
  path: "/cadastro-reordenamento-planejamento",
  redirect: "/cadastro-reordenamento-planejamento",
  meta: {
    breadCrumb: "",
  },
  children: [
    {
      path: "/cadastro-reordenamento-planejamento",
      name: "cadastro-reordenamento-planejamento",
      component: () =>
        import(
          "@/views/CadastroDoReordenamentoPlanejamento/CadastroDoReordenamentoPlanejamentoHome.vue"
        ),
    },
    {
      path: "/cadastro-reordenamento-planejamento/novo",
      name: "cadastro-reordenamento-planejamento-novo",
      component: () =>
        import(
          "@/views/CadastroDoReordenamentoPlanejamento/CadastroDoReordenamentoPlanejamentoCad.vue"
        ),
    },
    {
      path: "/cadastro-reordenamento-planejamento/edit/:id",
      name: "cadastro-reordenamento-planejamento-edit",
      component: () =>
        import(
          "@/views/CadastroDoReordenamentoPlanejamento/CadastroDoReordenamentoPlanejamentoEdit.vue"
        ),
    },
  ],
};

export { cadastro_reordenamento_planejamento };
